import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';
import { useKycStatus } from '@shared/hooks/use-associate';

// Mandatory KYC gate. While status is NOT_SUBMITTED or REJECTED, this dialog
// is non-dismissible and shown on every associate page except /associate/kyc
// itself (so the user can actually fill it in). Reappears every login until
// KYC is submitted — the banner continues to surface PENDING once submitted.
export function KycGate() {
  const { data: status } = useKycStatus();
  const navigate = useNavigate();
  const location = useLocation();

  if (!status) return null;
  if (status.status === 'VERIFIED' || status.status === 'PENDING') return null;
  if (location.pathname.startsWith('/associate/kyc')) return null;

  const rejected = status.status === 'REJECTED';

  return (
    <Dialog
      open
      onClose={() => {
        /* non-dismissible — KYC is mandatory */
      }}
      title={rejected ? 'KYC needs resubmission' : 'Complete your KYC'}
      footer={
        <Button onClick={() => navigate('/associate/kyc')}>
          {rejected ? 'Resubmit KYC' : 'Complete KYC now'}
        </Button>
      }
    >
      <p className="text-sm text-gray-700">
        {rejected
          ? 'Your KYC submission was rejected by the admin. You cannot be assigned new work until you correct and resubmit.'
          : 'You need to submit your KYC details before you can be assigned new transactions. It takes about 5 minutes.'}
      </p>
      {rejected && status.rejectionReason ? (
        <p className="mt-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
          <span className="font-medium">Reason:</span> {status.rejectionReason}
        </p>
      ) : (
        <ul className="mt-3 list-disc space-y-1 pl-5 text-xs text-gray-600">
          <li>Aadhaar + PAN (scan or photo)</li>
          <li>Bank account details for payouts</li>
          <li>Registered address</li>
        </ul>
      )}
    </Dialog>
  );
}
